import { loadAudioDefaults } from '../audio/AudioDefaults';

// v2: bumped after raising the default mix.music level so existing localStorage
// values from the old 0.14 default don't override the louder new default.
const STORAGE_KEY = 'tst:music-volume:v2';

type Listener = (volume: number) => void;

function clamp01(value: number): number {
  return Math.max(0, Math.min(1, value));
}

function defaultVolume(): number {
  return clamp01(loadAudioDefaults().mix.music);
}

function readVolume(): number {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw === null) return defaultVolume();
    const parsed = Number(raw);
    return Number.isFinite(parsed) ? clamp01(parsed) : defaultVolume();
  } catch {
    return defaultVolume();
  }
}

let volume = readVolume();
const listeners = new Set<Listener>();

export const musicVolume = {
  get(): number {
    return volume;
  },
  set(next: number): void {
    volume = clamp01(next);
    try {
      localStorage.setItem(STORAGE_KEY, String(volume));
    } catch {
      /* ignore */
    }
    listeners.forEach((listener) => listener(volume));
  },
  subscribe(listener: Listener): () => void {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
};
